import * as InsurersMapper from "./insurers.mappers";

const InsurersDataMapper = {
  InsurersMapper,
};

export default InsurersDataMapper;
